import { Menu, Newspaper } from "lucide-react";

export default function MobileTopBar({ onOpen }) {
  return (
    <div className="md:hidden flex items-center justify-between px-4 py-3 border-b border-[var(--border)] bg-white sticky top-0 z-20">
      <button
        onClick={onOpen}
        aria-label="Open menu"
        data-testid="mobile-menu-button"
        className="p-1.5 -ml-1.5 text-[var(--ink)] hover:bg-[var(--secondary)]"
      >
        <Menu className="w-5 h-5" />
      </button>
      <div className="flex items-center gap-1.5">
        <Newspaper className="w-3.5 h-3.5 text-[var(--accent)]" />
        <span className="font-mono-display text-sm font-bold tracking-[0.18em]">
          NEWSDESK
        </span>
      </div>
      <div className="w-8" />
    </div>
  );
}
